/**
 * Host allowlist for GitHub-controlled domains, kept React-free so both the
 * pure reference parser (`github-references`) and any other consumer can
 * validate model-supplied URLs without pulling UI dependencies.
 */

/**
 * Base domains GitHub controls. A host matches when it equals one of these
 * exactly or is a dotted subdomain of one (e.g. `tenant.ghe.com`). `ghe.com`
 * covers proxima tenants; the `.localhost` entries cover local development.
 */
const GITHUB_CONTROLLED_DOMAINS = ['github.com', 'ghe.com', 'github.localhost', 'ghe.localhost']

/**
 * Whether `hostname` belongs to a GitHub-controlled domain.
 *
 * Matches the exact domain or a dotted subdomain (`sub.github.com`), never a
 * bare suffix — so lookalikes such as `faux-github.com` or
 * `github.com.evil.com` are rejected. Comparison is case-insensitive.
 */
export function isGitHubControlledHost(hostname: string): boolean {
  const host = hostname.toLowerCase()
  return GITHUB_CONTROLLED_DOMAINS.some(domain => host === domain || host.endsWith(`.${domain}`))
}
